import Project from './Project';

export type IndicatorProjectQueryStatus = 'idle' | 'loading' | 'succeeded' | 'failed';

export interface IndicatorProjectQuery {
  data: Project[];
  status: IndicatorProjectQueryStatus;
  error: string | null;
  requestId: string | null;
}

export interface IndicatorProjectQueriesState {
  [queryKey: string]: IndicatorProjectQuery | undefined;
}

export const createInitialIndicatorProjectQuery = (): IndicatorProjectQuery => ({
  data: [],
  status: 'idle',
  error: null,
  requestId: null,
});
